export default __webpack_public_path__ + "assets/icons/formDelete.cb5afc50.svg";